
export {
	PlayButton,
	PauseButton,
	ForwardButton,
	BackwardButton,
	GoEndButton,
	GoStartButton,
	CommandButton,
	TabButton,
	LinkButton,
	SetupVideoButton,
	TableRowPlayButton,
	TableRowSyncButton
};

import {ipx} from './utils.js';
import {Arrow} from './glyphs.js';

// ---------------------------
// BUTTONS
// ---------------------------


function FlexButton(kind, w, h, listener) {

	// ---------------------------
	// Main Container
	// ---------------------------

	var b              = document.createElement("div");
	b.className        = "flex_button";
	b.btype            = "FlexButton";
	b.style.width      = ipx(w);
	b.style.height     = ipx(h);
	b.style.lineHeight = ipx(h+2);


	// ---------------------------
	// Properties
	// ---------------------------

	b.kind        = kind;
	b.selected    = false;
	b.disabled    = false;

	b.borderclr      = {};
	b.borderclr.up   = "#555555";
	b.borderclr.over = "#666666";
	b.borderclr.down = "#444444";
	b.borderclr.sel  = "#999999";
	b.borderclr.dis  = "#222222";

	b.bgcolor        = {};
	b.bgcolor.up     = "#444444";
	b.bgcolor.over   = "#555555";
	b.bgcolor.down   = "#333333";
	b.bgcolor.sel    = "#222222";
	b.bgcolor.dis    = "#111111";

	b.txtcolor       = {};
	b.txtcolor.up    = "#999999";
	b.txtcolor.over  = "#99dd00";
	b.txtcolor.down  = "#99bb00";
	b.txtcolor.sel   = "#99cc00";
	b.txtcolor.dis   = "#333333";


	// ---------------------------
	// Functions
	// ---------------------------

	b.onmouseover = f_onmouseover;
	b.onmouseout  = f_onmouseout;
	b.onmousedown = f_onmousedown;
	b.onclick     = f_onclick;
	b.select      = f_select;
	b.deselect    = f_deselect;
	b.enable      = f_enable;
	b.disable     = f_disable;


	// ---------------------------
	// Public Methods
	// ---------------------------

	function f_select(tf) {

		if (b.disabled) {
			return;
		}

		// Get the setting
		b.selected = (tf != undefined) ? tf : true;

		// Set the styles
		b.style.borderColor     = (b.selected == true) ? b.borderclr.sel : b.borderclr.up;
		b.style.backgroundColor = (b.selected == true) ? b.bgcolor.sel   : b.bgcolor.up;
		b.style.color           = (b.selected == true) ? b.txtcolor.sel  : b.txtcolor.up;

		if (b.do_select != undefined) {
			b.do_select(tf);
		}
	}

	function f_deselect() {
		f_select(false);
	}

	function f_enable(tf) {

		tf = (tf != undefined) ? tf : true;

		// Get the setting
		b.disabled = ! tf;

		if (b.disabled) {

			b.style.borderColor     = b.borderclr.dis;
			b.style.backgroundColor = b.bgcolor.dis;
			b.style.color           = b.txtcolor.dis;

			b.selected = false;

		} else {

			if (b.selected) {
				f_select();
			} else {
				f_deselect();
			}
		}

		if (b.do_enable != undefined) {
			b.do_enable(tf);
		}
	}

	function f_disable() {
		f_enable(false);
	}


	// ---------------------------
	// Event Methods
	// ---------------------------

	function f_onmouseover() {

		if (b.selected) { return; }
		if (b.disabled) { return; }

		b.style.borderColor     = b.borderclr.over;
		b.style.backgroundColor = b.bgcolor.over;
		b.style.color           = b.txtcolor.over;

		if (b.do_mouseover != undefined) {
			b.do_mouseover();
		}
	}

	function f_onmouseout() {

		if (b.selected) { return; }
		if (b.disabled) { return; }

		b.style.borderColor     = b.borderclr.up;
		b.style.backgroundColor = b.bgcolor.up;
		b.style.color           = b.txtcolor.up;

		if (b.do_mouseout != undefined) {
			b.do_mouseout();
		}
	}

	function f_onmousedown() {

		if (b.selected) { return; }
		if (b.disabled) { return; }

		b.style.borderColor     = b.borderclr.down;
		b.style.backgroundColor = b.bgcolor.down;
		b.style.color           = b.txtcolor.down;

		if (b.do_mousedown != undefined) {
			b.do_mousedown();
		}
	}

	function f_onclick() {

		if (b.disabled) {
			return;
		}

		if (b.kind == 'sticky') {
			f_select(true);

		} else if (b.kind == 'toggle') {
			f_select(! b.selected);

		} else if (b.kind == 'normal') {
			f_onmouseout();
		}

		if (listener != undefined) {
			listener.clicked(b);
		}
	}


	// ---------------------------
	// Return
	// ---------------------------

	b.deselect();
	return b;
}


function PlayButton(w, h, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = FlexButton('normal', w, h, listener);

	// Play Arrow
	var arrow = Arrow(9, "#999999", "E");
	arrow.style.marginLeft = ipx(Math.floor(w/2) - 3);
	arrow.style.marginTop  = ipx(Math.floor((h-18)/2));

	// Add the arrow
	b.appendChild(arrow);


	// ---------------------------
	// Functions
	// ---------------------------

	b.do_mouseover = f_do_mouseover;
	b.do_mouseout  = f_do_mouseout;
	b.do_mousedown = f_do_mousedown;
	b.do_select    = f_do_select;
	b.do_enable    = f_do_enable;


	// ---------------------------
	// Methods
	// ---------------------------

	function f_do_mouseover() {
		arrow.style.borderLeftColor = "#99dd00";
	}

	function f_do_mouseout() {
		arrow.style.borderLeftColor = "#999999";
	}

	function f_do_mousedown() {
		arrow.style.borderLeftColor = "#99bb00";
	}

	function f_do_select() {
		arrow.style.borderLeftColor = "#99cc00";
	}

	function f_do_enable(tf) {
		arrow.style.borderLeftColor = (tf == true) ? "#999999" : "#222222";
	}


	// ---------------------------
	// Return
	// ---------------------------

	return b;
}


function PauseButton(w, h, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = FlexButton('normal', w, h, listener);

	// Pause Bars
	var pb1              = document.createElement('div');
	pb1.className        = "pause_bar";
	pb1.style.marginLeft = ipx(Math.floor((w/2)-6));
	pb1.style.marginTop  = ipx(Math.floor((h-16)/2));

	var pb2              = document.createElement('div');
	pb2.className        = "pause_bar";
	pb2.style.marginTop  = ipx(Math.floor((h-16)/2));

	// Add the pause bars
	b.appendChild(pb1);
	b.appendChild(pb2);

	// ---------------------------
	// Functions
	// ---------------------------

	b.do_mouseover = f_do_mouseover;
	b.do_mouseout  = f_do_mouseout;
	b.do_mousedown = f_do_mousedown;
	b.do_select    = f_do_select;
	b.do_enable    = f_do_enable;

	// ---------------------------
	// Methods
	// ---------------------------

	function f_do_mouseover() {
		pb1.style.background = "#99dd00";
		pb2.style.background = "#99dd00";
	}

	function f_do_mouseout() {
		pb1.style.background = "#999999";
		pb2.style.background = "#999999";
	}

	function f_do_mousedown() {
		pb1.style.background = "#99bb00";
		pb2.style.background = "#99bb00";
	}

	function f_do_select() {
		pb1.style.background = "#99cc00";
		pb2.style.background = "#99cc00";
	}

	function f_do_enable(tf) {
		pb1.style.background = (tf == true) ? "#999999" : "#222222";
		pb2.style.background = (tf == true) ? "#999999" : "#222222";
	}

	// ---------------------------
	// Return
	// ---------------------------

	return b;
}


function ForwardButton(w, h, label, num_arrows, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = FlexButton('normal', w, h, listener);

	// Add the label
	b.style.font       = "normal 15px helvetica";
	b.style.lineHeight = ipx(h+2);
	b.innerHTML        = label;

	// Forward Arrows
	b.arrows = [];
	for (let i = 0; i < num_arrows; i++) {
		b.arrows[i]                 = Arrow(7, "#999999", "E");
		b.arrows[i].style.cssFloat  = "right";
		b.arrows[i].style.marginTop = ipx(Math.floor((h-14)/2));
		b.appendChild(b.arrows[i]);
	}

	// Set margins for first and last arrows
	b.arrows[0].style.marginRight            = ipx(5);
	b.arrows[num_arrows-1].style.marginLeft  = ipx(5);

	// ---------------------------
	// Functions
	// ---------------------------

	b.do_mouseover = f_do_mouseover;
	b.do_mouseout  = f_do_mouseout;
	b.do_mousedown = f_do_mousedown;
	b.do_select    = f_do_select;
	b.do_enable    = f_do_enable;

	// ---------------------------
	// Methods
	// ---------------------------

	function f_do_mouseover() {
		for (let i = 0; i < num_arrows; i++) {
			b.arrows[i].style.borderLeftColor = "#99dd00";
		}
	}

	function f_do_mouseout() {
		for (let i = 0; i < num_arrows; i++) {
			b.arrows[i].style.borderLeftColor = "#999999";
		}
	}

	function f_do_mousedown() {
		for (let i = 0; i < num_arrows; i++) {
			b.arrows[i].style.borderLeftColor = "#99bb00";
		}
	}

	function f_do_select() {
		for (let i = 0; i < num_arrows; i++) {
			b.arrows[i].style.borderLeftColor = "#99cc00";
		}
	}

	function f_do_enable(tf) {
		for (let i = 0; i < num_arrows; i++) {
			b.arrows[i].style.borderLeftColor = (tf == true) ? "#999999" : "#222222";
		}
	}

	// ---------------------------
	// Return
	// ---------------------------

	return b;
}


function BackwardButton(w, h, label, num_arrows, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = FlexButton('normal', w, h, listener);

	// Add the label
	b.style.font       = "normal 15px helvetica";
	b.style.lineHeight = ipx(h+2);
	b.innerHTML        = label;

	// Backward Arrows
	b.arrows = [];
	for (let i = 0; i < num_arrows; i++) {
		b.arrows[i]                 = Arrow(7, "#999999", "W");
		b.arrows[i].style.marginTop = ipx(Math.floor((h-14)/2));
		b.appendChild(b.arrows[i]);
	}

	// Set margins for first and last arrows
	b.arrows[0].style.marginLeft             = ipx(5);
	b.arrows[num_arrows-1].style.marginRight = ipx(5);


	// ---------------------------
	// Functions
	// ---------------------------

	b.do_mouseover = f_do_mouseover;
	b.do_mouseout  = f_do_mouseout;
	b.do_mousedown = f_do_mousedown;
	b.do_select    = f_do_select;
	b.do_enable    = f_do_enable;


	// ---------------------------
	// Methods
	// ---------------------------

	function f_do_mouseover() {
		for (let i = 0; i < num_arrows; i++) {
			b.arrows[i].style.borderRightColor = "#99dd00";
		}
	}

	function f_do_mouseout() {
		for (let i = 0; i < num_arrows; i++) {
			b.arrows[i].style.borderRightColor = "#999999";
		}
	}

	function f_do_mousedown() {
		for (let i = 0; i < num_arrows; i++) {
			b.arrows[i].style.borderRightColor = "#99bb00";
		}
	}

	function f_do_select() {
		for (let i = 0; i < num_arrows; i++) {
			b.arrows[i].style.borderRightColor = "#99c00";
		}
	}

	function f_do_enable(tf) {
		for (let i = 0; i < num_arrows; i++) {
			b.arrows[i].style.borderRightColor = (tf == true) ? "#999999" : "#222222";
		}
	}


	// ---------------------------
	// Return
	// ---------------------------

	return b;
}


function GoEndButton(w, h, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = FlexButton('normal', w, h, listener);

	// Arrow
	var arrow = Arrow(9, "#999999", "E");
	arrow.style.marginLeft = ipx(Math.floor(w/2) - 8);
	arrow.style.marginTop  = ipx(Math.floor((h-18)/2));

	// Pause Bar
	var pb              = document.createElement('div');
	pb.className        = "pause_bar";
	pb.style.marginLeft = ipx(2);
	pb.style.marginTop  = ipx(Math.floor((h-16)/2));

	// Add the pause bars
	b.appendChild(arrow);
	b.appendChild(pb);

	// ---------------------------
	// Functions
	// ---------------------------

	b.do_mouseover = f_do_mouseover;
	b.do_mouseout  = f_do_mouseout;
	b.do_mousedown = f_do_mousedown;
	b.do_select    = f_do_select;
	b.do_enable    = f_do_enable;

	// ---------------------------
	// Methods
	// ---------------------------

	function f_do_mouseover() {
		pb.style.background         = "#99dd00";
		arrow.style.borderLeftColor = "#99dd00";
	}

	function f_do_mouseout() {
		pb.style.background         = "#999999";
		arrow.style.borderLeftColor = "#999999";
	}

	function f_do_mousedown() {
		pb.style.background         = "#99bb00";
		arrow.style.borderLeftColor = "#99bb00";
	}

	function f_do_select() {
		pb.style.background         = "#99cc00";
		arrow.style.borderLeftColor = "#99cc00";
	}

	function f_do_enable(tf) {
		pb.style.background         = (tf == true) ? "#999999" : "#222222";
		arrow.style.borderLeftColor = (tf == true) ? "#999999" : "#222222";
	}

	// ---------------------------
	// Return
	// ---------------------------

	return b;
}


function GoStartButton(w, h, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = FlexButton('normal', w, h, listener);

	// Pause Bar
	var pb              = document.createElement('div');
	pb.className        = "pause_bar";
	pb.style.marginLeft = ipx(Math.floor(w/2) - 8);
	pb.style.marginTop  = ipx(Math.floor((h-16)/2));

	// Arrow
	var arrow = Arrow(9, "#999999", "W");
	arrow.style.marginLeft = ipx(2);
	arrow.style.marginTop  = ipx(Math.floor((h-18)/2));

	// Add the pause bars
	b.appendChild(pb);
	b.appendChild(arrow);

	// ---------------------------
	// Functions
	// ---------------------------

	b.do_mouseover = f_do_mouseover;
	b.do_mouseout  = f_do_mouseout;
	b.do_mousedown = f_do_mousedown;
	b.do_select    = f_do_select;
	b.do_enable    = f_do_enable;

	// ---------------------------
	// Methods
	// ---------------------------

	function f_do_mouseover() {
		pb.style.background          = "#99dd00";
		arrow.style.borderRightColor = "#99dd00";
	}

	function f_do_mouseout() {
		pb.style.background          = "#999999";
		arrow.style.borderRightColor = "#999999";
	}

	function f_do_mousedown() {
		pb.style.background          = "#99bb00";
		arrow.style.borderRightColor = "#99bb00";
	}

	function f_do_select() {
		pb.style.background          = "#99cc00";
		arrow.style.borderRightColor = "#99cc00";
	}

	function f_do_enable(tf) {
		pb.style.background          = (tf == true) ? "#999999" : "#222222";
		arrow.style.borderRightColor = (tf == true) ? "#999999" : "#222222";
	}

	// ---------------------------
	// Return
	// ---------------------------

	return b;
}


function CommandButton(w, h, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = FlexButton('normal', w, h, listener);

	// ---------------------------
	// Custom Colors
	// ---------------------------

	b.borderclr.up   = "#ffcc00";
	b.borderclr.over = "#ffdd00";
	b.borderclr.down = "#ffbb00";
	b.borderclr.sel  = "#ff9900";
	b.borderclr.dis  = "#dddddd";

	b.bgcolor        = {};
	b.bgcolor.up     = "#ff9900";
	b.bgcolor.over   = "#ffaa00";
	b.bgcolor.down   = "#ff8800";
	b.bgcolor.sel    = "#ff9900";
	b.bgcolor.dis    = "#eeeeee";

	b.txtcolor       = {};
	b.txtcolor.up    = "#ffffff";
	b.txtcolor.over  = "#ffffff";
	b.txtcolor.down  = "#ffffff";
	b.txtcolor.sel   = "#ffffff";
	b.txtcolor.dis   = "#ffffff";

	// ---------------------------
	// Return
	// ---------------------------

	b.deselect();
	return b;
}


function TabButton(w, h, label, page, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	//var b       = FlexButton('sticky', w, h, listener);  // now using css instead of w/h
	var b       = FlexButton('sticky', null, null, listener);
	b.innerHTML = label;
	b.tab_page  = page;
	$(b).addClass('tab_sel_button');

	// Styling
	b.style.font                    = "normal 14px helvetica";
	b.style.lineHeight              = ipx(h);
	b.style.marginBottom            = ipx(0);
	b.style.marginRight             = ipx(5);
	b.style.borderBottomLeftRadius  = ipx(0);
	b.style.borderBottomRightRadius = ipx(0);
	b.style.borderWidth             = ipx(1);
	b.style.borderBottomWidth       = ipx(0);

	// ---------------------------
	// Custom Colors
	// ---------------------------

	b.borderclr.up   = "#999999";
	b.borderclr.over = "#aaaaaa";
	b.borderclr.down = "#888888";
	b.borderclr.sel  = "#999999";
	b.borderclr.dis  = "#222222";

	b.bgcolor        = {};
	b.bgcolor.up     = "#555555";
	b.bgcolor.over   = "#666666";
	b.bgcolor.down   = "#444444";
	b.bgcolor.sel    = "#f8f8ff";
	b.bgcolor.dis    = "#333333";

	b.txtcolor       = {};
	b.txtcolor.up    = "#999999";
	b.txtcolor.over  = "#aaaaaa";
	b.txtcolor.down  = "#888888";
	b.txtcolor.sel   = "#666666";
	b.txtcolor.dis   = "#444444";

	// ---------------------------
	// Return
	// ---------------------------

	b.deselect();
	return b;
}


function LinkButton(w, h, label, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = FlexButton('sticky', w, h, listener);
	b.innerHTML = label;

	// ---------------------------
	// Style Adjustments
	// ---------------------------

	b.style.borderTop   = "none";
	b.style.borderLeft  = "none";
	b.style.borderRight = "none";
	b.style.font        = "normal 14px helvetica";
	b.style.lineHeight  = ipx(h);
	b.style.borderRadius= ipx(0);

	// ---------------------------
	// Custom Colors
	// ---------------------------

	b.borderclr.up   = "transparent";
	b.borderclr.over = "transparent";
	b.borderclr.down = "#666666";
	b.borderclr.sel  = "#ff9900";
	b.borderclr.dis  = "#eeeeee";

	b.bgcolor        = {};
	b.bgcolor.up     = "transparent";
	b.bgcolor.over   = "transparent";
	b.bgcolor.down   = "transparent";
	b.bgcolor.sel    = "transparent";
	b.bgcolor.dis    = "transparent";

	b.txtcolor       = {};
	b.txtcolor.up    = "#777777";
	b.txtcolor.over  = "#888888";
	b.txtcolor.down  = "#666666";
	b.txtcolor.sel   = "#ff9900";
	b.txtcolor.dis   = "#eeeeee";

	// ---------------------------
	// Return
	// ---------------------------

	b.deselect();
	return b;
}


function TableRowButton(w, h, label, dataobj, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = FlexButton('normal', w, h, listener);
	b.innerHTML = label;
	b.dataobj   = dataobj;


	// ---------------------------
	// Style Adjustments
	// ---------------------------

	b.style.font        = "normal 12px helvetica";
	b.style.lineHeight  = ipx(h);
	b.style.margin      = "2px 0px 0px 5px";

	// ---------------------------
	// Custom Colors
	// ---------------------------

	b.borderclr.up   = "#aaaaaa";
	b.borderclr.over = "#bbbbbb";
	b.borderclr.down = "#ffaa00";
	b.borderclr.sel  = "#ff9900";
	b.borderclr.dis  = "#eeeeee";

	b.bgcolor        = {};
	b.bgcolor.up     = "#999999";
	b.bgcolor.over   = "#aaaaaa";
	b.bgcolor.down   = "#ff9900";
	b.bgcolor.sel    = "#ff9900";
	b.bgcolor.dis    = "#dddddd";

	b.txtcolor       = {};
	b.txtcolor.up    = "#ffffff";
	b.txtcolor.over  = "#ffffff";
	b.txtcolor.down  = "#ffffff";
	b.txtcolor.sel   = "#ffffff";
	b.txtcolor.dis   = "#ffffff";

	// ---------------------------
	// Return
	// ---------------------------

	b.deselect();
	return b;
}


function SetupVideoButton(w, h, label, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = TableRowButton(w, h, label, null, listener);

	// ---------------------------
	// Style Adjustments
	// ---------------------------

	b.style.margin     = "0px 0px 5px 5px";
	b.style.font       = "normal 13px arial,helvetica";
	b.style.lineHeight = ipx(h);

	// ---------------------------
	// Return
	// ---------------------------

	b.deselect();
	return b;
}


function TableRowPlayButton(w, h, dataobj, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = TableRowButton(w, h, "", dataobj, listener);
	b.btype = "TableRowPlayButton";

	// Play Arrow
	var arrow = Arrow(6, "#99cc00", "E");
	arrow.style.marginLeft = ipx(Math.floor(w/2) - 3);
	arrow.style.marginTop  = ipx(Math.floor((h-12)/2));

	// Add the arrow
	b.appendChild(arrow);

	// ---------------------------
	// Functions
	// ---------------------------

	b.do_mouseover = f_do_mouseover;
	b.do_mouseout  = f_do_mouseout;
	b.do_mousedown = f_do_mousedown;
	b.do_select    = f_do_select;
	b.do_enable    = f_do_enable;

	// ---------------------------
	// Methods
	// ---------------------------

	function f_do_mouseover() { arrow.style.borderLeftColor = "#99ee00"; }
	function f_do_mouseout()  { arrow.style.borderLeftColor = "#99cc00"; }
	function f_do_mousedown() { arrow.style.borderLeftColor = "#ffffff"; }
	function f_do_select()    { arrow.style.borderLeftColor = "#99cc00"; }
	function f_do_enable(tf)  { arrow.style.borderLeftColor = (tf == true) ? "#99cc00" : "#eeeeee"; }

	// ---------------------------
	// Return
	// ---------------------------

	return b;
}


function TableRowSyncButton(w, h, dataobj, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	// Flex button
	var b = TableRowButton(w, h, "&infin;", dataobj, listener);
	b.btype = "TableRowSyncButton";

	// ---------------------------
	// Style Adjustments
	// ---------------------------

	b.style.font        = "normal 20px helvetica";
	b.style.lineHeight  = ipx(h+4);

	b.txtcolor       = {};
	b.txtcolor.up    = "#99cc00";
	b.txtcolor.over  = "#99ee00";
	b.txtcolor.down  = "#ffffff";
	b.txtcolor.sel   = "#99cc00";
	b.txtcolor.dis   = "#eeeeee";

	// ---------------------------
	// Return
	// ---------------------------

	b.deselect();
	return b;
}


